<template>
  <v-container fluid>
    <v-row justify="center" align="center" v-if="loading">
      <div class="text-center">
        <div>
          <v-progress-circular
            class="my-4"
            :size="50"
            width="5"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </div>
        <p class="display-1">{{ $t("Loading") }}...</p>
      </div>
    </v-row>
    <v-row dense v-if="!loading">
      <v-col md="6" sm="12">
        <v-card>
          <v-card-title>
            <v-icon large left> mdi-cogs </v-icon>
            <span class="title font-weight-light">{{ $t("General") }}</span>
          </v-card-title>
          <v-card-text>
            <v-switch
              v-model="parameter.DashboardCacheEnabled"
              @change="cacheToggleChanged"
              color="green"
              :label="$t('ParamDashboardCache')"
            ></v-switch>
            <v-text-field
              :label="$t('ParamWebsiteURL')"
              v-model="parameter.WebsiteURL"
            ></v-text-field>
            <v-text-field
              :label="$t('ParamWebApiURL')"
              v-model="parameter.WebApiURL"
            ></v-text-field>
            <v-text-field
              :label="$t('ParamAutorecognitionApiURL')"
              v-model="parameter.AutorecognitionApiURL"
            ></v-text-field>
            <v-text-field
              :label="$t('ParamJobsExecutionTime')"
              v-model="parameter.JobsExecutionTime"
            ></v-text-field>
            <v-textarea
              :label="$t('ParamSupportedFileFormats')"
              v-model="parameter.SupportedFileFormats"
            >
              <template v-slot:append>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on"> mdi-help-circle-outline </v-icon>
                  </template>
                  {{ $t("ParamSupportedFileFormatsInfo") }}
                </v-tooltip>
              </template>
            </v-textarea>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col md="6" sm="12">
        <v-card>
          <v-card-title>
            <v-icon large left> mdi-server-security </v-icon>
            <v-switch
              v-model="parameter.ActiveDirectoryAuthEnabled"
              color="green"
              :label="$t('ParamActiveDirectory')"
            ></v-switch>
          </v-card-title>
          <v-card-text v-if="parameter.ActiveDirectoryAuthEnabled">
            <v-text-field
              v-model="parameter.ActiveDirectoryServerPath"
              :label="$t('Server')"
            >
              <template v-slot:append>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on"> mdi-help-circle-outline </v-icon>
                  </template>
                  LDAP://srv-ecm.adserver.local
                </v-tooltip>
              </template>
            </v-text-field>
            <v-text-field
              :label="$t('ParamActiveDirectoryDomain')"
              v-model="parameter.ActiveDirectoryDomain"
            >
              <template v-slot:append>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on"> mdi-help-circle-outline </v-icon>
                  </template>
                  adserver.local
                </v-tooltip>
              </template>
            </v-text-field>
            <v-text-field
              :label="$t('ParamActiveDirectoryAllowedUserGroups')"
              v-model="parameter.ActiveDirectoryAllowedUserGroups"
            ></v-text-field>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row dense v-if="!loading">
      <v-col md="6" sm="12">
        <v-card>
          <v-card-title>
            <v-icon large left> mdi-security </v-icon>
            <v-switch
              v-model="parameter.SAMLEnabled"
              color="green"
              :label="$t('SAML')"
            ></v-switch>
          </v-card-title>
          <v-card-text v-if="parameter.SAMLEnabled">
            <v-text-field
              :label="$t('ParamSAMLEndpoint')"
              v-model="parameter.SAMLEndpoint"
            ></v-text-field>
            <v-textarea
              v-model="parameter.SAMLCertificate"
              :label="$t('ParamSAMLCertificate')"
            ></v-textarea>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col md="6" sm="12" v-show="false">
        <v-card>
          <v-card-title>
            <v-icon large left> mdi-draw </v-icon>
            <v-switch
              v-model="parameter.SwissIDEnabled"
              color="green"
              :label="$t('QualifiedElectronicSignature')"
            ></v-switch>
          </v-card-title>
          <v-card-text v-if="parameter.SwissIDEnabled">
            <v-text-field
              :label="$t('Login')"
              v-model="parameter.SwissIDLogin"
            ></v-text-field>
            <v-text-field
              :label="$t('Password')"
              v-model="parameter.SwissIDPassword"
            ></v-text-field>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-fab-transition>
      <v-tooltip left>
        <template v-slot:activator="{ on }">
          <v-btn
            color="primary"
            v-on="on"
            dark
            absolute
            bottom
            right
            fab
            :loading="loadingSave"
            class="mb-10"
            @click="save"
          >
            <v-icon large>mdi-content-save</v-icon>
          </v-btn>
        </template>
        <span>{{ $t("Save") }}</span>
      </v-tooltip>
    </v-fab-transition>
  </v-container>
</template>

<script>
import ParameterService from "@/services/ParameterService";
import Parameter from "@/ecm/models/Parameter";
import Utils from "@/ecm/common/Utils";

export default {
  mounted() {
    this.getParameters();
  },
  data() {
    return {
      loading: false,
      loadingSave: false,
      parameter: new Parameter(),
      cacheChanged: false,
    };
  },
  methods: {
    getParameters() {
      this.loading = true;
      ParameterService.getAll().then((data) => {
        console.log(data);
        this.parameter = new Parameter(data);
        this.loading = false;
      });
    },
    cacheToggleChanged() {
      this.cacheChanged = true;
    },
    save() {
      this.loadingSave = true;
      ParameterService.save(this.parameter.toDto()).then((data) => {
        let message =
          this.$t("Parameters") + " " + this.$t("SavedSuccessfully");
        if (this.cacheChanged && this.parameter.DashboardCacheEnabled) {
          message += ". " + this.$t("RebootAPIToApplyCacheChanges");
        }
        Utils.toast.success(message);
        this.getParameters();
        this.loadingSave = false;
      });
    },
  },
};
</script>
